<template>
  <Navbar :url="imgurl " />
  <div class="homepage">
    <h1>Homepage</h1>
    <div v-if="error">{{ error }}</div>
    <div v-if="posts" class='layout'>
      <Postlist :posts="posts" />
      <Tagcloud :posts="posts" />
    </div>
    <div v-else>
      <Spinner/>
    </div>
  </div>
</template>

<script>
import Postlist from '../components/Postlist'
import Spinner from '../components/Spinner'
import Tagcloud from '../components/Tagcloud'
import Navbar from '../components/Navbar'

import getPosts from '../composables/getPosts'
import { ref } from 'vue'
import getUser from '../composables/getUser'

export default {
  name: 'Blog',
  components: {
    Postlist,
    Spinner,
    Tagcloud,
    Navbar
  },
  setup() {
    const { posts, error } = getPosts('posts'); // 將getPosts中的posts,error,load解構挑出以使用
    const { imgurl } = getUser();
    return { posts, error, imgurl }; 
    // return posts, error給template使用
    // const posts = ref([]);放posts
    // const error = ref(null);
    // const showPost = ref(true); // toggle flag
    // const load = async () => {  // 非同步function取資料
    //   try{  // 若是promise錯誤，則會跑catch，成功則不會跑catch
    //     let data = await fetch('http://localhost:3004/posts');
    //     // fetch取資料，await等待資料傳回來，再把物件傳給左邊的data變數，data會是一promise物件
    //     if(!data.ok){// promise物件中的ok property為false，則丟error，去跑catch
    //       throw Error('no data available!')
    //     }
    //     posts.value = await data.json(); // 將promise物件轉成json回傳
    //   }
    //   catch(err) {
    //     error.value = err.message
    //   }
    // }
  },
}
</script>

<style>
  .homepage {
    max-width: 1200px;
    margin: 0 auto;
    padding: 10px;
  }
  .layout {
    display: grid;
    grid-template-columns: 3fr 1fr;
    gap: 20px;
  }
</style>